import dropdownFilterUrl from './dropdownFilter.html';

class DropdownFilterCtrl {
  constructor(focus, $scope, $element) {
    'ngInject';

    Object.assign(this, { $scope, $element, focus });
  }

  $onInit() {
    if (this.pluralizeName === undefined) {
      this.pluralizeName = true;
    }

    this.searchProperty = this.getSearchProperty();
    this.search = this.searchProperty ? { [this.searchProperty]: '' } : '';

    this.$scope.$watch('ctrl.dropdownOpened', (open) => {
      if (open) {
        this.search = this.searchProperty ? { [this.searchProperty]: '' } : '';
        this.focus('search');
      }
    });

    this.$scope.$watch('ctrl.filterOptions.length', (show) => {
      this.$element[show ? 'removeClass' : 'addClass']('is-empty');
    });
  }

  getSearchProperty() {
    const SEARCH_BY_NAME = ['location', 'positon', 'group', 'tag'];
    const SEARCH_BY_FULLNAME = ['user', 'employee'];

    if (SEARCH_BY_FULLNAME.includes(this.displayName)) {
      return 'fullname';
    }

    if (SEARCH_BY_NAME.includes(this.displayName)) {
      return 'name';
    }

    return null;
  }
}

export default {
  templateUrl: dropdownFilterUrl,
  controllerAs: 'ctrl',
  controller: DropdownFilterCtrl,
  transclude: {
    button: '?dropdownFilterButton',
    options: 'dropdownFilterOptions',
  },
  bindings: {
    displayName: '@',
    allButtonText: '<?',
    clearFilters: '&',
    filterOptions: '=',
    titlePrefix: '@?',
    filterLength: '=',
    hideSearch: '<',
    noMaxHeight: '<?',
    formControl: '<?',
    noIcon: '<?',
    dropdownOpened: '=?',
    compact: '<?',
    pluralizeName: '<?',
  },
};
